var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.29,514.29h-231.43V25.71c0-14.21-11.5-25.71-25.71-25.71H282.86c-14.21,0-25.71,11.5-25.71,25.71v488.57H25.71c-14.21,0-25.71,11.5-25.71,25.71v514.29c0,14.21,11.5,25.71,25.71,25.71h1028.57c14.21,0,25.71-11.5,25.71-25.71v-514.29c0-14.21-11.5-25.71-25.71-25.71ZM758.57,565.71h77.14v77.14h-77.14v-77.14ZM578.57,51.43v77.14h-77.14V51.43h77.14ZM308.57,51.43h141.43v102.86c0,14.21,11.5,25.71,25.71,25.71h128.57c14.21,0,25.71-11.5,25.71-25.71V51.43h141.43v462.86h-462.86V51.43ZM282.86,565.71h38.57v77.14h-77.14v-77.14h38.57ZM51.43,565.71h141.43v102.86c0,14.21,11.5,25.71,25.71,25.71h128.57c14.21,0,25.71-11.5,25.71-25.71v-102.86h141.43v462.86H51.43v-462.86ZM1028.57,1028.57h-462.86v-462.86h141.43v102.86c0,14.21,11.5,25.71,25.71,25.71h128.57c14.21,0,25.71-11.5,25.71-25.71v-102.86h141.43v462.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIcon);
export default __webpack_public_path__ + "static/media/StockIcon.714c49dac8f1375dec9b91407678045c.svg";
export { ForwardRef as ReactComponent };